import { configureApi } from 'lp-requests'
import useAuth from 'components/auth/useAuth'

export const useFastApi = (authToken = null) => {
  const { getAccessTokenSilently } = useAuth()

  const fastApiConfig = {
    root: process.env.REACT_APP_SEA_TOW_FAST_API,
    before: async () => {
      const token = authToken || await getAccessTokenSilently()
      return {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    },
    onSuccess: (res) => res,
    onFailure: (error) => {
      throw error
    },
    mode: 'cors',
  }

  return configureApi(fastApiConfig)
}